import React from 'react';
import ReactDOM from 'react-dom';
import Pages from './pages/index';
import '../src/styles/index.css';
import "antd/dist/antd.css";
import { HashRouter } from 'react-router-dom';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            preLoading: true,
        };
    }

    render() {
        return <HashRouter basename={"/"}>
                    <Pages />
             </HashRouter>
    }
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
